<template>
    <div class="settings" :class="{ 'active': isActive, 'inactive': !isActive }" ref="settings">
        <div class="caret" @click="openSettings">
            <i class="fa fa-sliders"></i>
        </div>
        
        <div class="buttons">
            <slot :toggleSettings="openSettings"></slot>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isActive: false
        }
    },
    methods: {
        openSettings() {
            this.isActive = !this.isActive
        }
    }
}
</script>

<style scoped lang="scss">
.settings {
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    width: auto;
    background-color: var(--bg-card);
    border-radius: 10px 0px 0px 10px;
    right: 0;
    opacity: 0.7;
    z-index: 9999;
    box-shadow: -4px 0 12px rgba(0, 0, 0, 0.3);
    transition: all 0.3s ease;

    &.inactive {
        opacity: 0.9;
        
        .caret {
            background: linear-gradient(135deg, var(--primary-start), var(--primary-end));
            color: var(--text-on-button);
            border: 2px solid var(--primary-start);
            
            &:hover {
                transform: translateY(-50%) scale(1.1);
                box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
            }
        }
    }

    &.active {
        right: 0;
        opacity: 1;
        box-shadow: none;

        .buttons {
            display: block;
        }
        
        .caret {
            background-color: var(--border-default);
            color: var(--text-primary);
            border: none;
        }
    }

    .buttons {
        display: none;
    }

    .btn {
        display: block;
        margin: 10px;
        width: calc(100% - 20px);
        text-align: center;
        white-space: nowrap;
    }

    .caret {
        position: absolute;
        padding: 10px;
        top: 50%;
        transform: translateY(-50%);
        padding: 20px 5px;
        left: -15px;
        border-radius: 10px;
        cursor: pointer;
        transition: all 0.3s ease;
        
        &:hover {
            transform: translateY(-50%) scale(1.05);
        }
        
        i {
            font-size: 16px;
        }
    }
}

</style>